import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { CreateProfileRequest } from "../types/Profile";

export const useCreateProfile = () => {
  const { authHeader } = useAuth();

  return useMutation((params: CreateProfileRequest) => {
    return axios.post(`${env.verifyServiceUrl}individual/profile/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
